module.exports = __webpack_public_path__ + "img/footer-info-changed.8926c8e2.jpg";